import React, { useEffect, useState } from "react";
import { Col, Collapse, Divider, Form, Input, Row, Tooltip } from "antd";
import moment from "moment";
import { FormInstance } from "antd/es/form/Form";
import versionsTableUtils from "../../../../lib/utils/versionsTableUtils";
import { useAppDispatch, useAppSelector } from "../../../..";
import { PolicyTreeTable } from "../PolicyTreeTable/PolicyTreeTable";
import { PolicyNotTreeTable } from "../PolicyNotTreeTable/PolicyNotTreeTable";
import { ReactComponent as LoupeIcon } from "../../../../img/loupe-icon.svg";
import { IParameterSearchType } from "../../context/PoliciesContext/types";
import { useActiveModal } from "../../../../lib/utils";
import { ReactComponent as OfferingIcon } from "../../../../img/offering-icon.svg";
import { ReactComponent as GroupOfferingIcon } from "../../../../img/group-offering-icon.svg";
import { OfferListModal } from "../../../../components/OfferList/OfferListModal/OfferListModal";
import { OfferingGroupsSearchModal } from "../OfferingGroupsSearchModal/OfferingGroupsSearchModal";
import { IOfferingGroup } from "../../types/IOfferingGroup";
import { useOfferList } from "../../../../components/OfferList/utils/useOfferList";
import { Offer } from "../../../../lib/types";
import { searchOfferingGroupForPolicyCreate } from "../../store/slice/policiesSlice";
import "./PolicyTable.less";
import HistoryAndPropertyModal from "../../../../components/HistoryAndPropertyModal/HistoryAndPropertyModal";
import { IPolicySearch } from "../../types/IPolicySearch";
import { IPolicy } from "../../types/IPolicy";

interface ComponentProps {
  mode?: "create" | "view" | "edit_close_date" | "edit";
  selectedTypeId?: number;
  policyParamsForm?: FormInstance<IPolicySearch>;
  assocOffering?: IPolicy["assocOffering"];
  assocOfferingGroup?: IPolicy["assocOfferingGroup"];
  actorOffering?: IPolicy["actorOffering"];
  actorOfferingGroup?: IPolicy["actorOfferingGroup"];
}

export const PolicyTable = ({
  mode,
  selectedTypeId,
  policyParamsForm,
  assocOffering,
  assocOfferingGroup,
  actorOffering,
  actorOfferingGroup,
}: ComponentProps) => {
  const { policiesTypesDic } = useAppSelector((state) => state.policies);

  const [firstParameterOfferingGroup, setFirstParameterOfferingGroup] = useState<IOfferingGroup>();
  const [firstParameterOffer, setFirstParameterOffer] = useState<Offer>();
  const [
    secondParameterOfferingGroup,
    setSecondParameterOfferingGroup,
  ] = useState<IOfferingGroup>();
  const [secondParameterOffer, setSecondParameterOffer] = useState<Offer>();

  const dispatch = useAppDispatch();

  const getTitleForType = (titleSelect: 1 | 2): string => {
    const policyTypeTitle = {
      VALIDATE: {
        1: "Область применения",
        2: "Область значений",
      },
      INTERACTION: {
        1: "Участник 1",
        2: "Участник 2",
      },
      REQUIRE: {
        1: "Дочерние Предложения",
        2: "Родительские Предложения",
      },
      BUNDLE: {
        1: "Параметр 1",
        2: "Параметр 2",
      },
    };

    const type = versionsTableUtils.getDictionaryItemById(policiesTypesDic, selectedTypeId)?.alias;

    return type ? policyTypeTitle[type][titleSelect] : policyTypeTitle.BUNDLE[titleSelect];
  };

  const [firstParameterSearchType, setFirstParameterSearchType] = useState<IParameterSearchType>(
    "offering_group"
  );

  const toggleFirstParameterSearchType = () => {
    setFirstParameterSearchType(
      firstParameterSearchType === "offering" ? "offering_group" : "offering"
    );
  };

  const [secondParameterSearchType, setSecondParameterSearchType] = useState<IParameterSearchType>(
    "offering_group"
  );

  const toggleSecondParameterSearchType = () => {
    setSecondParameterSearchType(
      secondParameterSearchType === "offering" ? "offering_group" : "offering"
    );
  };

  const initialViewState = (): void => {
    setFirstParameterSearchType("offering_group");
    setSecondParameterSearchType("offering_group");

    let og1: any = null;
    let o1: any = null;
    let og2: any = null;
    let o2: any = null;

    if (assocOffering) {
      setFirstParameterOffer(assocOffering);
      setFirstParameterOfferingGroup(undefined);
      o1 = assocOffering;

      policyParamsForm &&
        policyParamsForm.setFieldsValue({
          assocObjectId: assocOffering.id,
          assocObjectName: assocOffering.extName,
          assocTypeAlias: "offering",
        });
    }
    if (assocOfferingGroup) {
      policyParamsForm &&
        policyParamsForm.setFieldsValue({
          assocObjectId: assocOfferingGroup.id,
          assocObjectName: assocOfferingGroup.name,
          assocTypeAlias: "offering_group",
        });

      dispatch(searchOfferingGroupForPolicyCreate(assocOfferingGroup.id)).then((res) => {
        setFirstParameterOfferingGroup(res.payload);
        og1 = res.payload;
        setFirstParameterOffer(undefined);
      });
    }
    if (actorOffering) {
      setSecondParameterOffer(actorOffering);
      setSecondParameterOfferingGroup(undefined);
      o2 = actorOffering;

      policyParamsForm &&
        policyParamsForm.setFieldsValue({
          actorId: actorOffering.id,
          actorName: actorOffering.extName,
          actorTypeAlias: "offering",
        });
    }
    if (actorOfferingGroup) {
      policyParamsForm &&
        policyParamsForm.setFieldsValue({
          actorId: actorOfferingGroup.id,
          actorName: actorOfferingGroup.name,
          actorTypeAlias: "offering_group",
        });

      dispatch(searchOfferingGroupForPolicyCreate(actorOfferingGroup.id)).then((res) => {
        og2 = res.payload;
        console.log({ og2 });
        setSecondParameterOfferingGroup(res.payload);
        setSecondParameterOffer(undefined);
      });
    }

    console.log("view-1", { assocOffering, assocOfferingGroup, actorOffering, actorOfferingGroup });
    console.log("view-2", {
      firstParameterOfferingGroup: og1,
      firstParameterOffer: o1,
      secondParameterOfferingGroup: og2,
      secondParameterOffer: o2,
    });
  };

  useEffect(() => {
    initialViewState();
  }, [assocOffering, assocOfferingGroup, actorOffering, actorOfferingGroup]);

  // При нажатии отмены редактирования и создания новой версии сбрасывать таблицу до изначального состояния
  useEffect(() => {
    if (mode === "view") {
      initialViewState();
    }
  }, [mode]);

  // console.log("view-3", {
  //   firstParameterOfferingGroup,
  //   firstParameterOffer,
  //   secondParameterOfferingGroup,
  //   secondParameterOffer,
  // });

  const { activeModal, setActiveModal } = useActiveModal<"" | "assocObjectId" | "actorId">("");

  const closeModal = () => {
    setActiveModal("");
  };

  const offerListProps = useOfferList({
    initialOfferListViewMode: "selectOffer",
    initialSearchValues: { onDate: moment(), page: 0, size: 10 },
  });

  const submitOfferListModal = (offer: Offer) => {
    switch (activeModal) {
      case "assocObjectId":
        policyParamsForm &&
          policyParamsForm.setFieldsValue({
            assocObjectId: offer.id,
            assocObjectName: offer.extName,
            assocTypeAlias: "offering",
          });
        setFirstParameterOffer(offer);
        setFirstParameterOfferingGroup(undefined);
        offerListProps.onResetSearch();
        break;
      case "actorId":
        policyParamsForm &&
          policyParamsForm.setFieldsValue({
            actorId: offer.id,
            actorName: offer.extName,
            actorTypeAlias: "offering",
          });
        setSecondParameterOffer(offer);
        setSecondParameterOfferingGroup(undefined);
        offerListProps.onResetSearch();
        break;
    }
    closeModal();
  };

  const submitOfferingGroupsSearchModal = (offeringGroup: IOfferingGroup) => {
    switch (activeModal) {
      case "assocObjectId":
        policyParamsForm &&
          policyParamsForm.setFieldsValue({
            assocObjectId: offeringGroup.id,
            assocObjectName: offeringGroup.name,
            assocTypeAlias: "offering_group",
          });

        offerListProps.onResetSearch();

        offeringGroup?.id &&
          dispatch(searchOfferingGroupForPolicyCreate(offeringGroup.id)).then((res) => {
            setFirstParameterOffer(undefined);
            setFirstParameterOfferingGroup(res.payload);
          });

        break;
      case "actorId":
        policyParamsForm &&
          policyParamsForm.setFieldsValue({
            actorId: offeringGroup.id,
            actorName: offeringGroup.name,
            actorTypeAlias: "offering_group",
          });

        offeringGroup?.id &&
          dispatch(searchOfferingGroupForPolicyCreate(offeringGroup.id)).then((res) => {
            setSecondParameterOffer(undefined);
            setSecondParameterOfferingGroup(res.payload);
          });

        break;
    }
    closeModal();
  };

  const [visibleModal, setVisibleModal] = useState(false);
  const [objectId, setObjectId] = useState(null);

  const handleShowModal = (record) => {
    setVisibleModal(true);
    // setObjectDateFrom(objId.fromDate);
    // setObjectDateTo(objId.toDate);
    setObjectId(record.id);
  };

  const handleHideModal = () => {
    setVisibleModal(false);
    setObjectId(null);
  };

  return (
    <Row className="policy-table">
      <Divider style={{ margin: 0 }} />

      <Collapse style={{ width: "100%" }} bordered={false} defaultActiveKey="1">
        <Collapse.Panel
          key="1"
          header={
            <Row
              style={{ width: "100%" }}
              justify="space-between"
              className="offer-create-container__pageTitle"
            >
              <Row style={{ width: "100%" }} wrap={false}>
                <div className="noWrap">
                  <h3>{getTitleForType(1)}</h3>
                </div>
                <Form.Item
                  style={{ width: "100%" }}
                  className="form-item-required__hidden-error__mb0 policy-table__parameter"
                >
                  <Row>
                    <Col>
                      <Form.Item name="assocObjectName" rules={[{ required: true, message: "" }]}>
                        <Input
                          allowClear
                          placeholder={
                            firstParameterSearchType === "offering"
                              ? "Выберите предложение"
                              : "Выберите группу предложений"
                          }
                          disabled
                          style={{ width: "100%", maxWidth: 220 }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Row wrap={false}>
                        {firstParameterSearchType === "offering" && (
                          <OfferingIcon
                            className="policy-table__offerIcon"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleFirstParameterSearchType();
                            }}
                          />
                        )}
                        {firstParameterSearchType === "offering_group" && (
                          <GroupOfferingIcon
                            className="policy-table__offerIcon"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleFirstParameterSearchType();
                            }}
                          />
                        )}
                        <Tooltip title={!selectedTypeId ? "Выберите тип политики" : ""}>
                          <LoupeIcon
                            className="policy-table__loupeIcon"
                            style={{ marginLeft: 10 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (selectedTypeId) {
                                if (mode === "create" || mode === "edit") {
                                  setActiveModal("assocObjectId");
                                }
                              }
                            }}
                          />
                        </Tooltip>
                      </Row>
                    </Col>
                  </Row>
                </Form.Item>
              </Row>
            </Row>
          }
        >
          {firstParameterOfferingGroup && (
            <PolicyTreeTable
              handleShowHistoryModal={handleShowModal}
              offeringGroup={firstParameterOfferingGroup}
            />
          )}
          {firstParameterOffer && (
            <PolicyNotTreeTable
              handleShowHistoryModal={handleShowModal}
              offer={firstParameterOffer}
            />
          )}
        </Collapse.Panel>
      </Collapse>

      <Collapse style={{ width: "100%" }} bordered={false} defaultActiveKey="1">
        <Collapse.Panel
          key="1"
          header={
            <Row
              style={{ width: "100%" }}
              justify="space-between"
              className="offer-create-container__pageTitle"
            >
              <Row style={{ width: "100%" }} wrap={false}>
                <div className="noWrap">
                  <h3>{getTitleForType(2)}</h3>
                </div>
                <Form.Item
                  style={{ width: "100%" }}
                  className="form-item-required__hidden-error__mb0 policy-table__parameter"
                >
                  <Row>
                    <Col>
                      <Form.Item name="actorName" rules={[{ required: true, message: "" }]}>
                        <Input
                          allowClear
                          placeholder={
                            secondParameterSearchType === "offering"
                              ? "Выберите предложение"
                              : "Выберите группу предложений"
                          }
                          disabled
                          style={{ width: "100%", maxWidth: 220 }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Row wrap={false}>
                        {secondParameterSearchType === "offering" && (
                          <OfferingIcon
                            className="policy-table__offerIcon"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSecondParameterSearchType();
                            }}
                          />
                        )}
                        {secondParameterSearchType === "offering_group" && (
                          <GroupOfferingIcon
                            className="policy-table__offerIcon"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSecondParameterSearchType();
                            }}
                          />
                        )}
                        <Tooltip title={!selectedTypeId ? "Выберите тип политики" : ""}>
                          <LoupeIcon
                            className="policy-table__loupeIcon"
                            style={{ marginLeft: 10 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (selectedTypeId) {
                                if (mode === "create" || mode === "edit") {
                                  setActiveModal("actorId");
                                }
                              }
                            }}
                          />
                        </Tooltip>
                      </Row>
                    </Col>
                  </Row>
                </Form.Item>
              </Row>
            </Row>
          }
        >
          {secondParameterOfferingGroup && (
            <PolicyTreeTable
              offeringGroup={secondParameterOfferingGroup}
              handleShowHistoryModal={handleShowModal}
            />
          )}
          {secondParameterOffer && (
            <PolicyNotTreeTable
              handleShowHistoryModal={handleShowModal}
              offer={secondParameterOffer}
            />
          )}
        </Collapse.Panel>
      </Collapse>

      <OfferListModal
        visible={
          (firstParameterSearchType === "offering" && activeModal === "assocObjectId") ||
          (secondParameterSearchType === "offering" && activeModal === "actorId")
        }
        onOk={submitOfferListModal}
        onCancel={closeModal}
        offerListProps={{ ...offerListProps, filterName: "group-offer" }}
      />
      <OfferingGroupsSearchModal
        visible={
          (firstParameterSearchType === "offering_group" && activeModal === "assocObjectId") ||
          (secondParameterSearchType === "offering_group" && activeModal === "actorId")
        }
        policyTypeId={selectedTypeId}
        isParamPlace={activeModal === "assocObjectId" ? "first" : "second"}
        onCancel={closeModal}
        onSubmit={submitOfferingGroupsSearchModal}
      />
      <HistoryAndPropertyModal
        objectTypeSysname="offering_policy"
        objectId={objectId}
        handleHideModal={handleHideModal}
        visibleModal={visibleModal}
        // dateObjectFromForCalendar={objectDateFrom}
        // dateObjectToForCalendar={objectDateTo}
        // hasAccessToEdit={hasAccess(MENU_ACCOUNT_SERVICES_WRITE)}
      />
    </Row>
  );
};

export default PolicyTable;
